import React, { Component } from 'react'
import { Input, Button, message } from 'antd'
import intl from 'react-intl-universal'
import { INPUT_TIP, PATTERN } from '@/config/default'
import { getCode } from '@/services/mfa'
import { throttle } from 'lodash'

class VerifyCode extends Component {
  state = {
    count: 0,
    accountValid: false
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.type !== this.props.type) {
      this.setState({ count: 0 })
      clearInterval(this.interval)
    }
    if (prevProps.accountValue !== this.props.accountValue) {
      this.setState({
        accountValid: this.props.noAccount
          ? false
          : this.props.form
            ? this.props.accountValue
             ? !PATTERN[this.props.type].test(this.props.accountValue)
             : true
            : false
      })
    }
  }

  handleAccount = (e) => {
    const value = e.target.value
    this.props.onChange && this.props.onChange(value)
    this.props.onBlur && this.props.onBlur(value)
  }

  handleSendCode = throttle(async () => {
    const { type } = this.props
    const value = this.props.form.getFieldValue(type.toLocaleLowerCase())
    if (!value) {
      type === 'MOBILE' && message.error(INPUT_TIP.MOBILE_EMPTY)
      type === 'EMAIL' && message.error(INPUT_TIP.EMAIL_EMPTY)
      return
    }
    this.setState({ count: 60 })
    try {
      await getCode({
        [type.toLocaleLowerCase()]: value,
        type: type
      })
      this.countDown(60)
    } catch (error) {
      this.setState({ count: 0 })
      console.log('获取验证码失败：', error)
    }
  }, 100)

  handleSendCodeNoAccount = throttle(async () => {
    this.setState({ count: 60 })
    const { type } = this.props
    try {
      await getCode({
        type: type
      })
      this.countDown(60)
    } catch (error) {
      this.setState({ count: 0 })
      console.log('获取验证码失败：', error)
    }
  }, 100)

  /** 按钮倒计时 */
  countDown = (time) => {
    let count = time
    this.interval = setInterval(() => {
      count -= 1
      this.setState({ count })
      if (count === 0) {
        clearInterval(this.interval)
      }
    }, 1000)
  }

  render () {
    const { value, placeholder = intl.get('mfa.pleaseEnterTheCode'), noAccount } = this.props
    const { count, accountValid } = this.state
    // const accountValid = noAccount ? false : this.props.form ? this.props.form.getFieldError(type.toLocaleLowerCase()) : false
    return <Input.Group compact>
      <Input className='send-code-input' placeholder={placeholder} size="large" value={value} onChange={this.handleAccount} onBlur={this.handleAccount} />
      <Button className='send-code-btn' disabled={count > 0 || accountValid} size="large" onClick={noAccount ? this.handleSendCodeNoAccount : this.handleSendCode}>
        {
          count > 0 ? intl.get('mfa.count_Resend', { count: count }) : intl.get('mfa.getCode')
        }
      </Button>
    </Input.Group>
  }
}

export default VerifyCode
